<template>
  <div class="lp-wave-content">
    <div class="lp-wave-login ly-row ly-center-center" v-load-fade-in="{ delay: 1000, timeBetween: 500 }">
      <transition name="fade">
        <div v-show="true" class="forgot-password-container card lp-load-fadein">
          <div>
            <NewForgotPasswordForm v-if="showForgotPasswordForm" @formSubmitted="onForgotPasswordFormSubmitted"
              :isSubmitting="submitting" />
            <ForgotPasswordRequested v-else />
            <div class="msg msg-error w-100 text-center" v-if="errorMessage">
              {{ errorMessage }}
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, inject, Ref } from 'vue'
import NewForgotPasswordForm from './components/NewForgotPasswordForm.vue'
import ForgotPasswordRequested from './components/ForgotPasswordRequested.vue'

const errorMessage: Ref<string> = ref('')
const showForgotPasswordForm: Ref<boolean> = ref(true)
const submitting: Ref<boolean> = ref(false)
let username

const forgotPassword = inject('forgotPassword') as (username: string, provider: string) => Promise<void>
const onForgotPasswordFormSubmitted = async (params: { email: string, provider: string }) => {
  if (submitting.value) return
  submitting.value = true
  errorMessage.value = ''
  try {
    await forgotPassword(params.email, params.provider)
    username = params.email
    showForgotPasswordForm.value = false
  } catch (error: any) {
    displayError({ message: 'Error trying to reset your password. Try again later' })
    console.log(error)
    submitting.value = false
  }
  submitting.value = false
}

const displayError = (error: any) => {
  error.message
    ? errorMessage.value = error.message
    : errorMessage.value = 'Unexpected Error'
}
</script>

<style scoped>
.forgot-password-container {
  background-color: transparent !important;
  width: 450px;
  text-align: center;
  box-shadow: none !important;
  padding-top: 0;
  padding-bottom: 120px !important;
}

.forgot-password-container .card {
  width: 550px;
  height: auto;
  box-shadow: none !important;
  background-color: transparent !important;
  padding-top: 0;
}

.forgot-password-container img {
  width: 200px;
  height: auto;
  margin: 0 auto;
  display: block;
}
</style>
